export const CloseIcon = () => (
  <svg
    role='presentation'
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    className='close-icon'
    viewBox='0 0 23 23'
  >
    <g fillRule='evenodd' fill='#d9666f'>
      <path d='M10.314 -3.686H12.314V26.314H10.314z' transform='rotate(-45 11.314 11.314)'></path>
      <path d='M10.314 -3.686H12.314V26.314H10.314z' transform='rotate(45 11.314 11.314)'></path>
    </g>
  </svg>
);
